import { useMemo } from "react"
import type { ChatSession } from "@stockline/shared/types/ai/chat-session"
import { CHAT_SESSION_TABLE } from "../../../lib/offline/resources/ai/chat-session/db"
import { useAISync } from "../providers/AISyncProvider"

export function useChatSessions(): ChatSession[] {
  const { reactive } = useAISync()
  const rows = reactive.useQuery<ChatSession>(CHAT_SESSION_TABLE, {
    orderBy: "-updatedAt",
  })
  // Tombstone filter — delta-pulls re-upsert soft-deleted sessions back into
  // Dexie with `deletedAt` set (server `findChangedSince` does not exclude
  // them and `buildPullResponse` emits every row as `upsert`). Hiding them
  // here is what makes a `chat-session.deleted` visibly drop the row.
  return useMemo(() => rows.filter((s) => !s.deletedAt), [rows])
}

export function useChatSession(id: string | null): ChatSession | null {
  const { reactive } = useAISync()
  const result = reactive.useOne<ChatSession>(CHAT_SESSION_TABLE, id ?? "")
  if (!id || !result || result.deletedAt) return null
  return result
}
